module.exports = __webpack_public_path__ + "img/per_statement.3da02a56.png";